module.exports = __webpack_public_path__ + "static/media/A-Diamond.9c56b68c.svg";